import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services';
import { EnvService } from 'src/app/shared/services/env.service';

@Component({
  selector: 'app-gift-order-confirmation',
  templateUrl: './gift-order-confirmation.component.html',
  styleUrls: ['./gift-order-confirmation.component.less']
})
export class GiftOrderConfirmationComponent implements OnInit {
  orderId: any;
  paymentType: string = 'card';
  totalAmount: number = 0;
  recipientName: string = '';
  recipientEmail: string = '';
  message: string = ''; 
  isLoading: boolean =true;


  constructor(private activateRouter:ActivatedRoute, private api:ApiService, private snackbar:MatSnackBar,
    public env:EnvService
  ) { 
    this.isLoading = true;
    this.orderId = this.activateRouter.snapshot.params['id'];
  }

  ngOnInit(): void { 
    this.api.getGiftCardReceipt(this.orderId).subscribe((res:any)=>{
      if(res && res.status){
        this.totalAmount = res.receipt.total_charged_cents;
        this.recipientName = res.receipt.recipient.name;
        this.recipientEmail = res.receipt.recipient.email;
        this.message = res.receipt.gift_message;
        this.paymentType = res.receipt.payment.brand + ' ' + res.receipt.payment.last4;
        this.isLoading = false;
      } else{
        this.snackbar.open('Receipt not found for this order.', 'x', { duration: 3000 });
      }
    }, err=>{
      this.snackbar.open('Receipt not found for this order.', 'x', { duration: 3000 });
    });
  }

}
